<div class="new-contract-sign">
  <h2>{{ 'NEW_CONTRACT_LA.SIGN_CONTRACT' | i18nextEager | uppercase }}</h2>
  <section class="new-contract-sign__container">
    <h2 class="new-contract-sign__title">
      {{ 'NEW_CONTRACT_LA.SELECT_SIGN' | i18nextEager | uppercase }}
    </h2>
    <div class="new-contract-sign__form">
      <span class="new-contract-sign__radio" (click)="handleToggle(0)">
        <img *ngIf="!digitalType" src="/assets/icons/radio-default.svg" alt="" />
        <img *ngIf="digitalType" src="/assets/icons/radio-select.svg" alt="" />
        {{ 'NEW_CONTRACT_LA.DIGITAL_SIGN' | i18nextEager }}
      </span>
      <span class="new-contract-sign__radio" (click)="handleToggle(1)">
        <img *ngIf="!paperType" src="/assets/icons/radio-default.svg" alt="" />
        <img *ngIf="paperType" src="/assets/icons/radio-select.svg" alt="" />
        {{ 'NEW_CONTRACT_LA.PAPER_SIGN' | i18nextEager }}
      </span>
    </div>
    <div *ngIf="paperType" class="new-contract-sign__download-container">
      <div class="new-contract-sign__download-block">
        <span class="new-contract-sign__download-title">
          {{ 'NEW_CONTRACT_LA.DOWNLOAD_CONTRACT' | i18nextEager }}
        </span>
        <button class="secondary new-contract-sign__download-button" (click)="handleDownload()">
          {{ 'COMMONS.DOWNLOAD' | i18nextEager }}
          <img src="/assets/icons/download_red.svg" alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}" />
        </button>
      </div>
    </div>
  </section>
</div>
